import {
  SAVE_ALL_HIGHLIGHTS,
  RESET_ALL_HIGHLIGHTS_DATA,
  SAVE_ALL_BOOKINGS,
  RESET_ALL_BOOKINGS,
  SAVE_ALL_ROOMS_LIST,
  RESET_ALL_ROOMS_LIST,
  SAVE_ALL_FACILITIES,
  RESET_ALL_FACILITIES_DATA,
  SAVE_USER_GAMES,
  RESET_USER_GAMES,
  SAVE_USER_GROUPS,
  RESET_USER_GROUPS,
  SAVE_ADS,
  RESET_ADS,
} from "../types";

const INITIAL_STATE = {
  highlights: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
  facilities: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
  bookings: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
  rooms: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
  userGames: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
  userGroups: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
  ads: {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
  },
};

const adminReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SAVE_ALL_HIGHLIGHTS:
      return {
        ...state,
        highlights: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_ALL_HIGHLIGHTS_DATA:
      return {
        ...state,
        highlights: INITIAL_STATE.highlights,
      };

    case SAVE_ALL_FACILITIES:
      return {
        ...state,
        facilities: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_ALL_FACILITIES_DATA:
      return {
        ...state,
        facilities: INITIAL_STATE.facilities,
      };

    case SAVE_ALL_BOOKINGS:
      return {
        ...state,
        bookings: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_ALL_BOOKINGS:
      return {
        ...state,
        bookings: INITIAL_STATE.bookings,
      };

    case SAVE_ALL_ROOMS_LIST:
      return {
        ...state,
        rooms: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_ALL_ROOMS_LIST:
      return {
        ...state,
        rooms: INITIAL_STATE.rooms,
      };

    case SAVE_USER_GAMES:
      return {
        ...state,
        userGames: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_USER_GAMES:
      return {
        ...state,
        userGames: INITIAL_STATE.userGames,
      };

    case SAVE_USER_GROUPS: {
      return {
        ...state,
        userGroups: {
          pageSize: 10,
          ...payload,
        },
      };
    }

    case RESET_USER_GROUPS: {
      return {
        ...state,
        userGroups: INITIAL_STATE.userGroups,
      };
    }

    case SAVE_ADS: {
      return {
        ...state,
        ads: {
          pageSize: 10,
          ...payload,
        },
      };
    }

    case RESET_ADS:{
      return {
        ...state,
        ads: INITIAL_STATE.ads
      }
    }
    default:
      return state;
  }
};

export default adminReducer;
